<template>
	<div class="body">
		<div class="inner-ctr" v-if="data">
			<div class="title">{{data.title}}</div>
			
			<div class="info-ctr">
				<div class="date">{{data.updated_at}}</div>
			</div>
			
			<div class="line"></div>
			
			<div class="cnt-ctr">
				<el-scrollbar class="cnt">
					<div v-html="data.content"></div>
				</el-scrollbar>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getIndex
	} from "@/api/article"

	export default {
		name: "About",
		data() {
			return {
				data: null
			}
		},
		created() {
			let params = this.$route.query
			this.initPageData(params.id);
		},
		methods: {
			initPageData(id) {
				getIndex({
					'id': id
				}).then(res => {
					this.data = res.data.data;
				});
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss">
	@use "article.scss";
</style>